export default (hit) => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' }
  const date = new Date(hit.date.date).toLocaleDateString(config.locale, options)

  const heightMobile = hit.type === 'expert-opinion' || hit.type === 'podcast' ? 500 : 240
  const heightDesktop = hit.type === 'expert-opinion' || hit.type === 'podcast' ? 540 : 240
  const tagTrad = config.trads[`publication.tag.${hit.type}`]
  const tradLabel = config.trads[`publication.cta.${hit.type}`]

  let color = 'blue'
  let textColor = 'night-blue'
  let titleColor = 'text-blue'

  if (hit.type === 'expert-opinion') {
    color = 'green'
    titleColor = 'text-white'
    textColor = 'white'
  } else if (hit.type === 'white-book') {
    color = 'red'
    titleColor = 'text-raspberry-red'
  } else if (hit.type === 'podcast') {
    color = 'yellow'
    titleColor = 'text-yellow'
    textColor = 'white'
  }

  return `
    <a href="${hit.path}" class="card card-publication ${hit.type === 'podcast' ? 'card-publication--podcast' : ''} text-${textColor}">
      <div class="card-publication__image ${hit.type === 'expert-opinion' || hit.type === 'podcast' ? 'card-publication__image--bg' : ''} ${hit.type === 'white-book' ? 'card-publication__image--illu' : ''}">
          ${hit.type !== 'white-book'
            ? `<picture>
                  <source media="(max-width: 420px)" srcset="https://res.cloudinary.com/drfuttoba/image/upload/c_fill,f_auto,q_auto,w_356,h_${heightMobile}/${hit.image.singleMedia.publicId} 1x, https://res.cloudinary.com/drfuttoba/image/upload/c_fill,f_auto,q_auto,w_712,dpr_2,h_${heightMobile * 2}/${hit.image.singleMedia.publicId} 2x"/>
                  <source media="(max-width: 767px)" srcset="https://res.cloudinary.com/drfuttoba/image/upload/c_fill,f_auto,q_auto,w_700,h_${heightMobile}/${hit.image.singleMedia.publicId} 1x, https://res.cloudinary.com/drfuttoba/image/upload/c_fill,f_auto,q_auto,w_1400,dpr_2,h_${heightMobile * 2}/${hit.image.singleMedia.publicId} 2x"/>
                  <source media="(min-width: 768px)" srcset="https://res.cloudinary.com/drfuttoba/image/upload/c_fill,f_auto,q_auto,w_556,h_${heightDesktop}/${hit.image.singleMedia.publicId} 1x, https://res.cloudinary.com/drfuttoba/image/upload/c_fill,f_auto,q_auto,w_1112,dpr_2,h_${heightDesktop * 2}/${hit.image.singleMedia.publicId} 2x"/>
                  <img class="w-full" src="https://res.cloudinary.com/drfuttoba/image/upload/c_fill,f_auto,q_auto,w_556,h_${heightDesktop}/${hit.image.singleMedia.publicId}" alt="${hit.image.singleMedia.alt}"/>
              </picture>`
            : `<img src="https://res.cloudinary.com/drfuttoba/image/upload/w_270,c_limit/${hit.image.singleMedia.publicId}" alt="${hit.image.singleMedia.alt}" class="card-publication__illu" />`
          }

          <span class="card-publication__tag card-publication__tag--${color}">${tagTrad}</span>
      </div>
      <div class="card-publication__infos flex flex-col ${hit.type === 'expert-opinion' || hit.type === 'podcast' ? 'justify-end' : 'justify-between'} flex-grow">
          <div>
              <p class="text-14 md:text-base mb-2 leading-5">${date}</p>
              <p class="font-weight-light ${titleColor} card-publication__title ${hit.type === 'white-book' ? 'card-publication__title--big' : ''} mb-4 md:mb-6">${hit.title}</p>
              ${hit.author !== null && hit.author !== undefined
                ? `<p class="card-author font-weight-light mb-9">${config.trads['publication.author']} <span class="font-weight-regular">${hit.author}</span></p>`
                : ''
              }
          </div>

          <span class="cta-link cta-link--${color}">${tradLabel}</span>
      </div>
    </a>
  `
}
